module.exports = __webpack_public_path__ + "img/cert-graphic.cda23f10.png";